import React, { useState } from "react";
import Constants from "../constants/Constants";
import { Link } from "@reach/router";
import { navigate } from "@reach/router";
import "../update.css";
const UpdateInfo = ({ snapchat, dispatch }) => {
  const [snap, setSnap] = useState(snapchat);
  const [canSubmit, setCanSubmit] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [saving, setSaving] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  const [error, setError] = useState("");
  const flashError = (err) => {
    setSaving(false);
    setError(err);
    setTimeout(() => {
      setError("");
    }, 4000);
  };
  const handleSave = () => {
    if (saving) {
      return false;
    }
    setSaving(true);
    let formData = new FormData();
    formData.append("cName", displayName);
    if (hasChanged) {
      if (snap > 30) {
        flashError("Its not possible to have a snapchat name this long.");
        return false;
      }
      formData.append("snapchat", snap);
    }

    if (displayName.length > 44) {
      flashError("Please make your Display Name less than 45 characters.");
      return false;
    }

    if (displayName.length < 4) {
      flashError("Please your Display Name greater than 3 characters");
      return false;
    }

    fetch(`${Constants.API}update-my-info.php`, {
      credentials: "include",
      method: "POST",
      body: formData,
      headers: {
        "X-XSRF-Header": Constants.XSRF,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (!("error" in res)) {
          if (hasChanged) {
            dispatch({
              type: "changeBothSnapchatAndComment",
              commentName: displayName,
              snap: snap,
            });
          } else {
            dispatch({
              type: "changeCommentName",
              payload: displayName,
            });
          }
          navigate(`${Constants.MA}subscriptions`);
        } else {
          flashError(res.error);
        }
      });
  };
  return (
    <div className="overlay">
      <div className="overlayHeader">Please Update Your Info</div>
      <div className="overlayInfo">
        <div className="overlayText">
          A <strong>Display Name</strong> is required. This will be used in your{" "}
          <Link to={`${Constants.MA}messages`}>Direct Messaging</Link> and
          comments. You may also provide your Snapname if you wish to follow the
          Creator on Snapchat.
        </div>
        <div className="overlayInputs">
          <div className="overlayInput">
            <i className="icon-message"></i>
            <input
              type="text"
              className="overlayInputBox"
              placeholder="Display Name"
              value={displayName}
              onChange={(e) => {
                setDisplayName(e.target.value);
                if (e.target.value.length > 3) {
                  setCanSubmit(true);
                } else {
                  setCanSubmit(false);
                }
              }}
            />
          </div>
          {error === "" ? (
            <div className="divider">- Optional -</div>
          ) : (
            <div className="overlayError">{error}</div>
          )}
          <div className="overlayInput">
            <i className="icon-snap"></i>
            <input
              type="text"
              className="overlayInputBox"
              placeholder="Snapname"
              value={snap}
              onChange={(e) => {
                if (!hasChanged) {
                  setHasChanged(true);
                }
                setSnap(e.target.value);
              }}
            />
            <Link to={`${Constants.MA}what-is-premium`}>
              Where do I find my snapname?
            </Link>

            {/* https://addfriends.com/vip/what-is-premium */}
          </div>
          <button
            className={canSubmit ? "overlaySave" : "overlaySave disabled"}
            onClick={() => {
              if (canSubmit) {
                handleSave();
              }
            }}
          >
            Save{" "}
            <div className={saving ? "nk-spinner show" : "nk-spinner"}></div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateInfo;
